import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { triggerSimpleAjax } from "../helpers/httpHelper";
import { PUSH_NOTIFICATION_DEVICE_UPDATE } from "../helpers/constants/apiUrl";
import { AppConfig } from "../app-config";

// const PUSH_SERVER_URL = process.env.REACT_APP_PUSH_SERVER_URL || "http://localhost:5001";
const PUSH_SERVER_URL = AppConfig.api_url;

// Firebase Configuration for project: my-track-12a49
const firebaseConfig = {
  projectId: "my-track-12a49",
  apiKey: "AIzaSyAjgnsThAXSgO1f1EkcbpEsT4_dINxPzcg",
  authDomain: "my-track-12a49.firebaseapp.com",
  storageBucket: "my-track-12a49.appspot.com",
  messagingSenderId: "736076458009",
  appId: "1:736076458009:web:dccfd96ed723862493a288"
};

// Initialize Firebase App safely
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

let messaging = null;
if (typeof window !== "undefined" && "serviceWorker" in navigator && "Notification" in window) {
  try {
    messaging = getMessaging(app);
  } catch (e) {
    console.warn("FCM messaging initialization warning:", e);
  }
}

class PushNotificationService {
  constructor() {
    this.registration = null;
    this.fcmToken = null;
    this.messageListeners = [];
    this.initForegroundListener();
  }

  isSupported() {
    return (
      typeof window !== "undefined" &&
      "serviceWorker" in navigator &&
      "PushManager" in window &&
      "Notification" in window
    );
  }

  getPermission() {
    if (!this.isSupported()) return "unsupported";
    return Notification.permission;
  }

  initForegroundListener() {
    if (messaging) {
      onMessage(messaging, (payload) => {
        console.log("🔔 [FCM Foreground Message Received]:", payload);
        const data = {
          title: payload.notification?.title || payload.data?.title || "RetailScan Alert",
          body: payload.notification?.body || payload.data?.body || "",
          icon: payload.notification?.icon || payload.data?.icon || "/favicons/android-icon-192x192.png",
          url: payload.data?.url || payload.fcmOptions?.link || "/dashboard",
          timestamp: Date.now(),
          data: payload.data || {}
        };
        this.messageListeners.forEach((fn) => {
          try {
            fn(data);
          } catch (err) {
            console.error("Error in FCM message listener:", err);
          }
        });
      });
    }

    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data && event.data.type === "PUSH_NOTIFICATION_RECEIVED") {
          console.log("📣 [ServiceWorker Push Received]:", event.data.payload);
          this.messageListeners.forEach((fn) => {
            try {
              fn(event.data.payload);
            } catch (err) {
              console.error("Error in SW message listener:", err);
            }
          });
        }
      });
    }
  }

  onMessage(callback) {
    if (typeof callback === "function") {
      this.messageListeners.push(callback);
    }
    return () => {
      this.messageListeners = this.messageListeners.filter((fn) => fn !== callback);
    };
  }

  async registerServiceWorker() {
    if (!this.isSupported()) {
      throw new Error("Push notifications are not supported in this browser.");
    }

    try {
      const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      this.registration = registration;
      console.log(`FirebaseToken Bhati11 >> 1101`);
      console.log("✅ Firebase Service Worker registered:", registration.scope);
      return registration;
    } catch (error) {
      console.error("❌ Firebase SW registration failed, falling back to /sw.js:", error);
      try {
        const swReg = await navigator.serviceWorker.register("/sw.js");
        this.registration = swReg;
        return swReg;
      } catch (fallbackErr) {
        throw fallbackErr;
      }
    }
  }

  extractFcmToken(subscription) {
    if (this.fcmToken) return this.fcmToken;
    if (!subscription || !subscription.endpoint) return null;
    if (subscription.endpoint.includes("/fcm/send/")) {
      return subscription.endpoint.split("/fcm/send/")[1];
    }
    return subscription.endpoint;
  }

  printFcmToken(token) {
    if (!token) return;
    console.log("%c======================================================", "color: #f59e0b; font-weight: bold;");
    console.log("%c🔥 [FCM Device Registration Token]:", "color: #f59e0b; font-weight: bold; font-size: 14px;");
    console.log(token);
    console.log("%c======================================================", "color: #f59e0b; font-weight: bold;");
  }

  async getExistingSubscription() {
    if (!this.isSupported()) return null;
    try {
      const registration = this.registration || (await navigator.serviceWorker.ready);
      const subscription = await registration.pushManager.getSubscription();
      if (subscription) {
        const token = this.extractFcmToken(subscription);
        if (token) {
          this.printFcmToken(token);
        }
      }
      return subscription;
    } catch (err) {
      console.error("Error getting push subscription:", err);
      return null;
    }
  }

  async getFcmToken() {
    if (this.fcmToken) {
      this.printFcmToken(this.fcmToken);
      return this.fcmToken;
    }
    return await this.requestFcmToken();
  }

  /**
   * Request permission, register SW, get native FCM token and synchronize with backend
   */
  async requestFcmToken(userId = "User") {
    if (!this.isSupported()) {
      console.warn("Push notifications are not supported in this browser.");
      return null;
    }

    console.log(`FirebaseToken Bhati11 >> START (Permission: ${Notification.permission})`);

    let permission = Notification.permission;
    if (permission !== "granted") {
      permission = await Notification.requestPermission();
    }

    if (permission !== "granted") {
      console.warn(`FirebaseToken Bhati11 >> Notification permission is ${permission}`);
      return null;
    }

    console.log(`FirebaseToken Bhati11 >> 0`);
    let registration = this.registration;
    if (!registration) {
      try {
        registration = await this.registerServiceWorker();
      } catch (swErr) {
        console.warn("Could not register Firebase Service Worker:", swErr);
      }
    }
    console.log(`FirebaseToken Bhati11 >> 0.1 >> >>`, registration);

    let token = null;
    if (messaging && registration) {
      try {
        token = await getToken(messaging, {
          serviceWorkerRegistration: registration,
          vapidKey: "BHom4fcABU7krDvymU2JtZxxKecoyKwSYeaiIBKbtDpwHqS-s--_8w-ocTzUQeSRohWwts-sX9OQ-16fVt1fGIA"
        });
        console.log(`FirebaseToken Bhati11 >> 5 ${token}`);
      } catch (err) {
        console.warn("Firebase getToken error, trying PushManager:", err.message);
      }
    }

    if (!token && registration && registration.pushManager) {
      try {
        const sub = await registration.pushManager.getSubscription();
        token = this.extractFcmToken(sub);
      } catch (pmErr) {
        console.warn("PushManager getSubscription error:", pmErr);
      }
    }


    if (token) {
      console.log(`FirebaseToken Bhati11 >> 10`);
      this.fcmToken = token;
      this.printFcmToken(token);

      const resolvedUser = userId || localStorage.getItem("userName") || localStorage.getItem("username") || "User";
      try {
        await this.sendSubscriptionToBackend({
          endpoint: `https://fcm.googleapis.com/fcm/send/${token}`
        }, resolvedUser, token);
      } catch (backendErr) {
        console.warn("Could not sync subscription with push server (server may be offline):", backendErr);
      }

      try {
        await this.updatePushNotificationDeviceToken(token);
      } catch (deviceUpdateErr) {
        console.warn("Could not update device token with backend API:", deviceUpdateErr);
      }

      return token;
    }

    console.log(`FirebaseToken Bhati11 >> 11`);
    return null;
  }

  async subscribe(userId = "User") {
    const token = await this.requestFcmToken(userId);
    const sub = await this.getExistingSubscription();
    return {
      subscription: sub || { endpoint: `https://fcm.googleapis.com/fcm/send/${token}` },
      fcmToken: token
    };
  }

  async sendSubscriptionToBackend(subscription, userId, fcmToken) {
    try {
      const token = fcmToken || this.extractFcmToken(subscription);
      const response = await fetch(`${PUSH_SERVER_URL}/api/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subscription,
          fcmToken: token,
          userId: userId || localStorage.getItem("userName") || localStorage.getItem("username") || "User",
          userAgent: navigator.userAgent
        })
      });

      if (!response.ok) {
        throw new Error(`Failed to save subscription on backend: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error sending subscription to backend:", error);
      throw error;
    }
  }

  async unsubscribe() {
    if (!this.isSupported()) return false;
    try {
      const registration = this.registration || (await navigator.serviceWorker.ready);
      const subscription = await registration.pushManager.getSubscription();
      if (subscription) {
        const endpoint = subscription.endpoint;
        await subscription.unsubscribe();
        try {
          await fetch(`${PUSH_SERVER_URL}/api/unsubscribe`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ endpoint })
          });
        } catch (apiErr) {
          console.warn("Backend unsubscribe failed:", apiErr);
        }
      }
      this.fcmToken = null;
      console.log("✅ Successfully unsubscribed");
      return true;
    } catch (error) {
      console.error("Error unsubscribing:", error);
      throw error;
    }
  }

  async sendTestNotification(customData = {}) {
    const payload = {
      title: customData.title || "🔔 Retail Hub Alert",
      body: customData.body || "Push notification test succeeded!",
      url: customData.url || "/dashboard",
      icon: customData.icon || "/favicons/android-icon-192x192.png"
    };

    const response = await fetch(`${PUSH_SERVER_URL}/api/send-notification`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.error || "Failed to send test push notification");
    }

    return await response.json();
  }

  async sendFcmNotification(customData = {}) {
    let token = customData.token || this.fcmToken;
    if (!token) {
      const sub = await this.getExistingSubscription();
      token = this.extractFcmToken(sub);
    }

    if (!token) {
      throw new Error("No active FCM device token found. Please enable notifications first.");
    }

    const payload = {
      token: token,
      title: customData.title || "🔥 RetailScan FCM Notification",
      body: customData.body || "FCM notification received successfully on this browser!",
      url: customData.url || "/dashboard",
      icon: customData.icon || "/favicons/android-icon-192x192.png",
      data: customData.data || {}
    };

    const response = await fetch(`${PUSH_SERVER_URL}/api/send-fcm`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.error || "Failed to send FCM notification");
    }

    return await response.json();
  }

  async updatePushNotificationDeviceToken(token) {
    const deviceToken = token || this.fcmToken;
    if (!deviceToken) {
      console.warn("No FCM device token available to send to PUSH_NOTIFICATION_DEVICE_UPDATE");
      return null;
    }

    const payload = {
      device_token: deviceToken,
      device_type: "web",
      platform: "retailhub"
    };

    console.log("📲 [PUSH_NOTIFICATION_DEVICE_UPDATE] Calling POST API with payload:", payload);

    return new Promise((resolve) => {
      triggerSimpleAjax(
        PUSH_NOTIFICATION_DEVICE_UPDATE,
        "POST",
        payload,
        (response) => {
          console.log("✅ [PUSH_NOTIFICATION_DEVICE_UPDATE] Device token updated successfully:", response);
          resolve(response);
        },
        (error) => {
          console.warn("⚠️ [PUSH_NOTIFICATION_DEVICE_UPDATE] Error updating device token:", error);
          resolve(null);
        }
      );
    });
  }
}

const pushNotificationService = new PushNotificationService();

// Export named helpers and default service instance
export const requestFcmToken = (userId) => pushNotificationService.requestFcmToken(userId);
export const onForegroundMessage = (callback) => pushNotificationService.onMessage(callback);
export const updatePushNotificationDeviceToken = (token) =>
  pushNotificationService.updatePushNotificationDeviceToken(token);
export default pushNotificationService;